<template>
  <div style="min-height: 200px; max-height: 500px;">
    <ProgressSpinner v-if="viewIsLoading"/>
    <div v-if="!viewIsLoading">
      <div class="ccm-image-cell-grid container-fluid ps-0" v-if="resultsFormFactor === 'grid'">
        <div v-for="(row, index) in rows" class="row text-center" :key="`${keyPrefix}-${index}`">
          <div  v-for="file in row" :key="`${keyPrefix}-${file}-grid`">
            <div v-if="file.title">
              <div class="ccm-image-cell" @click="() => onItemClick(file)" v-contextmenu="() => contextmenus(file)">
                <label class="form-label" :for="`file-${file.id}`">
                  <span v-if="file.isFolder"><IconFolderClose size="80"/></span>
                  <div v-else-if="slideLibraryActive && !file.isFolder && file.slides" >
                      <Carousel
                          :value="file.slides"
                          :numVisible="1"
                          :numScroll="1"
                          :showIndicators="false"
                          :class="{'hide-nav-buttons': file.slides.length === 1}"
                      >
                        <template #item="slotProps">
                          <div class="thumbnail-tile" @click="emitChosenFile(file)">
                            <ThumbnailSlide :slide="slotProps.data" :size="170" />
                          </div>
                        </template>
                      </Carousel>
                    <div style="font-size: 14px; width: 250px">{{ file.title }}
                      <span v-if="file.slides.length > 1" style="color: #999999; font-weight: normal; font-size: 14px">
                              ({{ file.slides.length }})
                      </span>
                    </div>
                  </div>
                  <div v-else>
                    <Image
                        :src="file.resultsThumbnailImg"
                        alt=""
                        preview
                    >
                      <template #indicatoricon>
                        <IconPreviewOpen @click="hideButtons"/>
                      </template>
                      <template #image>
                        <img :src="file.resultsThumbnailImg" alt=" " @click="emitChosenFile(file)"/>
                      </template>
                      <template #preview="slotProps">
                        <img :src="file.resultsThumbnailImg" alt=" " :style="slotProps.style"
                             @click="slotProps.onClick;"/>
                      </template>
                    </Image>
                  </div>
                </label>
<!--                <div class="delete-button-container">-->
<!--                  <Button icon="pi pi-trash" @click="emitDeleteFile(file)" />-->
<!--                </div>-->
                <div>
                  <label v-if="!file.slides" :for="`file-${file.id}`" class="radio-label">{{ file.title }}</label>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import {computed, nextTick, onMounted, onUnmounted, ref, toRefs, watch} from "vue";
import ProgressSpinner from 'primevue/progressspinner';
import {uuid} from 'vue-uuid'
import {useMainStore, useSlidesStore} from "@/store/index.ts";
import {storeToRefs} from "pinia"
import ThumbnailSlide from "@/views/components/ThumbnailSlide/index.vue";
import Draggable from "vuedraggable";
// import { ContextmenuItem } from '@/components/Contextmenu/types'



const props = defineProps({
  filters: {
    type: Array
  },
  keyPrefix: {
    type: String,
    required: false,
    default: ''
  },
  enableSort: {
    type: Boolean,
    required: false,
    default: false
  },
  enablePagination: {
    type: Boolean,
    required: false,
    default: false
  },
  resultsFormFactor: {
    type: String,
    required: false,
    default: 'grid' // grid | list
  },
  additionalQueryParams: {
    type: Array,
    required: false
  },
  routePath: {
    type: String,
    required: true
  },
  multipleSelection: {
    type: Boolean,
    default: true
  },
  refreshFiles: {
    type: Boolean,
    default: false
  },
  tempFiles: {
    type: Object,
    required: false
  },
  overrideActiveFolder: {
    type: Boolean
  }
})

const emit = defineEmits(['update:selectedFiles', 'folderClick', 'closeDialog', 'fileChosen', 'fileDelete']);
const mainStore = useMainStore()
const slidesStore = useSlidesStore()
const slides = ref([])

const hideCarouselNavButtons = (slides) => slides.length <= 1;

const {slideLibraryActive} = storeToRefs(mainStore)
const {valueModelId} = storeToRefs(slidesStore)
const library = ref()

const i18n = {
  id: 'ID',
  name: 'Name',
  uploaded: 'Uploaded',
  size: 'Size',
  width: 'Width',
  height: 'Height'
}

const currentPage = ref(1)
const perPage = ref(5)
const fileList = ref([])
const rows = ref([])
const selectedFiles = ref([])
const sortByColumn = ref('')
const sortByDirection = ref('desc')
const pagination = ref(null)
const queryParams = {
  pagination_page: 'ccm_paging_p',
  sort_column: 'ccm_order_by',
  sort_direction: 'ccm_order_by_direction'
}


const viewIsLoading = ref(false)
const isFolderItemList = computed(() => fileList.value.length > 0 && fileList.value[0].id !== undefined)
const dateSortColumn = computed(() => isFolderItemList.value ? 'dateModified' : 'f.fDateAdded')

const getSlides = async (url) => {
  const filePathSanitized = url.replace(/([^\/]+)$/, (match) =>
      match.replace(/\s+/g, '-').replace(/[^\w\-]/g, '')
  );


  const response = await window.fetch(`${import.meta.env.VITE_APP_ENV_SERVER}/lpi-service/library-slide-data?url=${filePathSanitized}`, {
    method: 'GET'
  })

  const data = await response.json()
  return data.slides
}


const fetchRoute = computed(() => {
  let routePath = overrideActiveFolderUrl.value ? overrideActiveFolderUrl.value : `${props.routePath}`

  let qs = '?'
  if (props.enablePagination && pagination.value) {
    routePath += `${qs}${queryParams.pagination_page}=${currentPage.value}&itemsPerPage=${pagination.value.per_page}`
    qs = '&'
  }

  if (Array.isArray(props.additionalQueryParams)) {
    for (const item of props.additionalQueryParams) {
      routePath += qs + encodeURIComponent(item.key) + '=' + encodeURIComponent(item.value)
      qs = '&'
    }
  }

  return routePath
})

const haveToPaginate = computed(() => props.enablePagination && pagination.value && pagination.value.total_pages > 1)

const displayedItems = computed(() => {
  const startIndex = (currentPage.value - 1) * perPage.value
  const endIndex = currentPage.value * perPage.value
  return fileList.value.slice(startIndex, endIndex)
})

const formatFirstColumn = (file) => {
  if (!file.isFolder) {
    return `<input type="radio" :disabled="!canChooseFile(file)" v-model="selectedFiles" :id="'file-' + file.id" :value="file" />`
  }
}

const formatSecondColumn = (file) => {
  if (file.isFolder) {
    return `<span><i class="fas fa-folder"></i></span>`
  } else {
    return `<span><img src="${file.resultsThumbnailImg}" style="max-width: 80px; max-height: 80px; margin: 8px;" alt="" /></span>`
  }
}

const canChooseFile = (file) => {
  let canChooseFile = -1
  if (props.filters) {
    const fileExtension = file.extension
    const fileType = file.genericType
    props.filters.forEach(filter => {
      if (filter.filter === 'extension') {
        canChooseFile = filter.extensions.includes(fileExtension)
      }
      if (canChooseFile !== false) {
        if (filter.filter === 'type') {
          canChooseFile = filter.type === fileType
        }
      }
    })
  }
  return canChooseFile === -1 ? true : canChooseFile
}

const {refreshFiles, tempFiles} = toRefs(props)


// watch(refreshFiles, () => getFiles())

// watch(tempFiles, (newVal) => {
//   rows.value[0].push(newVal)
// })


const overrideActiveFolderUrl = ref()
const getFiles = async () => {
  viewIsLoading.value = true;
  fileList.value = [];
  selectedFiles.value = [];
  slidesStore.clearLibrarySlides()

  try {
    let r;
    const response = await fetch(fetchRoute.value);
    r = await response.json();

    if (props.overrideActiveFolder) {
      const folder = r.data.find(item => item.title === 'Master Slides')
      overrideActiveFolderUrl.value = props.routePath.replace("/main/", `/main/${folder.id}`);
      const response = await fetch(fetchRoute.value);
      r = await response.json()
    }

    rows.value = []
    fileList.value = r.data || [];

    if (r.data && r.data.length > 0) {
      let currentRow = [];
      await Promise.all(
          r.data.map(async (file, i) => {
            if (!file.isFolder && slideLibraryActive.value) {
              file.slides = await getSlides(file.url);
            }
            currentRow.push(file);

            if (file.slides) {
              slidesStore.addLibrarySlides(file.slides)
            }
          })
      );

      if (currentRow.length) {
        while (currentRow.length < 5) {
          currentRow.push({id: uuid.v4()});
        }

        rows.value.push(currentRow);
      }
    }



    if (r.meta) {
      if (r.meta.pagination) {
        pagination.value = r.meta.pagination;
      }

      if (r.meta.query_params) {
        Object.assign(queryParams, r.meta.query_params);
      }

    }


    // Prevent re-fetching data
    // as changing pagination & queryParams data will fire `fetchRoute` watcher
    await nextTick();
    viewIsLoading.value = false;
  } catch (error) {
    console.error("Error fetching files:", error);
    viewIsLoading.value = false;
  }
}
const sortBy = (column) => {
  if (column === sortByColumn.value || (sortByColumn.value === '' && column === dateSortColumn.value)) {
    sortByDirection.value = sortByDirection.value === 'asc' ? 'desc' : 'asc'
  }

  sortByColumn.value = column
}


const getSortColumnClassName = (column) => {
  let className = ''
  if (props.enableSort) {
    if (column === sortByColumn.value || (sortByColumn.value === '' && column === dateSortColumn.value)) {
      className = `ccm-results-list-active-sort-${sortByDirection.value}`
    }
  }
  return className
}

const onItemClick = (file) => {
  if (file.isFolder) {
    emit('folderClick', file.id)
  }
}

const emitDeleteFile = async (file) => {
  rows.value.forEach((row) => {
    const fileIndex = row.findIndex(f => f.id === file.id);
    if (fileIndex !== -1) {
      row.splice(fileIndex, 1);
      return;
    }
  });
  emit('fileDelete', file)
}

onMounted(() => {
  if (window.ccmi18n_filemanager) {
    for (const key in i18n) {
      if (window.ccmi18n_filemanager[key]) {
        i18n[key] = window.ccmi18n_filemanager[key]
      }
    }
  }

})

onUnmounted(() => {
  slidesStore.clearLibrarySlides()
})



watch(currentPage, () => displayedItems.value)

watch(() => props.resultsFormFactor, (value) => {
  console.log('switching to/from grid/line')
})

watch(() => selectedFiles.value, (value) => {
  emit('update:selectedFiles', Array.isArray(value) ? value : [value])
})

watch(() => props.routePath, () => {
  currentPage.value = 1
})

watch(fetchRoute, () => {
  if (!viewIsLoading.value) {
    getFiles()
  }
}, {immediate: true})

const emitChosenFile = (file) => {
  emit('fileChosen', file)
}

const hideButtons = () => {
  setTimeout(() => {
    const actions = document.querySelectorAll('.p-image-action.p-link')
    actions[0].style.display = 'none'
    actions[1].style.display = 'none'
  }, 1)
}

const contextmenus = (file) => {
  return [
    {
      text: 'Delete',
      handler: () => {
        emitDeleteFile(file)
      },
    },
  ]
}

</script>
<style lang='scss' scoped>
/* stylelint-disable selector-pseudo-element-no-unknown */

.ccm-image-cell {
  margin-bottom: 20px;
}

.ccm-image-cell > label::v-deep i {
  font-size: 80px;
  margin: 2px;
  padding: 0.5rem;
}

.ccm-image-chooser-icon::v-deep i {
  font-size: 32px;
}

.form-label {
  height: 80px;
  width: 220px;

  .single-thumbnail {
    display: flex;
    justify-content: center;
  }
}

.row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-row-gap: 50px;
  margin-top: 2rem;
}

.radio-label {
  font-size: 12px;
}

:deep( .p-image ) > img {
  max-width: 80px;
  max-height: 80px;
  width: 80px;
  height: auto;
  margin: 8px;
}

:deep( .p-image-preview-indicator ) {
  height: 10px;
  background: none;
  color: #373a3c;
  top: auto !important;
  bottom: 0;
  padding-top: 10px !important;
}



:deep(.thumbnail-item) {
  display: flex;
  justify-content: center;
}

:deep(.p-carousel) {
  width: 250px;
}

:deep(.p-carousel-prev) {
  width: 1.5rem;
  height: 6rem;
  left: 35px;
  z-index: 1;
  bottom: 20px;
  border-radius: 2px;

}

:deep(.p-carousel-next) {
  width: 1.5rem;
  height: 6rem;
  right: 35px;
  bottom: 20px;
  border-radius: 2px;

}

:deep(.p-carousel-next .p-icon) {
  width: 1rem;
  height: 1rem;

}

:deep(.p-carousel-items-content) {
  border: 1px solid #eee;
  cursor: pointer;
}

:deep(.hide-nav-buttons .p-carousel-prev),
:deep(.hide-nav-buttons .p-carousel-next) {
  visibility: collapse;
}

</style>
